import Resource from "./resource";
import ActionProperties from "client/resources/actionProperties";

export class DeploymentActionResource extends Resource {
    Id: string;
    Name: string;
    ActionType: string;
    IsDisabled: boolean;
    Environments: string[];
    ExcludedEnvironments: string[];
    Channels: string[];
    TenantTags: string[];
    Properties: ActionProperties;
}

export default DeploymentActionResource;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/client/resources/deploymentActionResource.ts